import type { MenuChecklist } from '@restaurant/api-contracts';

export interface ProductIssues {
  noPrice: boolean;
  unknownCodes: string[];
}

export interface ChecklistSummary {
  issues: Map<string, ProductIssues>;
  total: number;
  unpriced: number;
  unknownAllergens: number;
}

export function summarizeChecklist(checklist: MenuChecklist): ChecklistSummary {
  const issues = new Map<string, ProductIssues>();
  const entry = (productId: string) => {
    const existing = issues.get(productId);
    if (existing) return existing;
    const created: ProductIssues = { noPrice: false, unknownCodes: [] };
    issues.set(productId, created);
    return created;
  };
  for (const item of checklist.unpriced) entry(item.productId).noPrice = true;
  for (const item of checklist.unknownAllergenCodes) {
    const target = entry(item.productId);
    target.unknownCodes = [...new Set([...target.unknownCodes, ...item.codes])];
  }
  return {
    issues,
    total: issues.size,
    unpriced: checklist.unpriced.length,
    unknownAllergens: checklist.unknownAllergenCodes.length,
  };
}

export function firstIssueRow(
  orderedProductIds: string[],
  issues: Map<string, ProductIssues>,
): string | null {
  return orderedProductIds.find((id) => issues.has(id)) ?? null;
}
